import React, { memo, useState } from 'react';
import { StyledWidgetImage, StyledWidgetImageWrapper } from 'adapter/in/common/components/widgets/Image/style';
import ImageData from 'domain/entity/widgets/ImageData';
import ErrorWidget from 'adapter/in/common/components/widgets/Error';
import i18n from 'asset/translation';
import { checkMemoChanges } from 'adapter/in/common/components/widgets/common/checkRedraw';

type WidgetImageProps = {
    data: ImageData;
    height: number;
    width: number;
    isLoading: boolean;
};

const WidgetImage = (props: WidgetImageProps) => {
    const { data, height, width, isLoading } = props;
    const [error, setError] = useState(false);

    return (
        <>
            {error && !isLoading ? (
                <ErrorWidget
                    width={width}
                    height={height}
                    errorTitle={i18n.t('widgets.error409')}
                    errorMessage={i18n.t('widgets.errorInvalidImageUrl')}
                    icon='error'
                />
            ) : (
                <StyledWidgetImageWrapper>
                    <StyledWidgetImage
                        data-testid='image-widget'
                        src={data.url}
                        alt='widget-pic'
                        $heightValue={height}
                        onError={() => {
                            setError(true);
                        }}
                    />
                </StyledWidgetImageWrapper>
            )}
        </>
    );
};

export default memo(WidgetImage, checkMemoChanges);
